import { render } from "./QualificationView.vue?vue&type=template&id=35152394"
import script from "./QualificationView.vue?vue&type=script&lang=js"
export * from "./QualificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__